import Tile from "@/components/form/Tile"
import { proxyProp } from "@/utils/proxyProp"
import { Required, defineComponent, type ReactiveComponent } from "vue-utils"
import { useCompanyContext } from "../context"

const Name: ReactiveComponent = () => {
	const context = useCompanyContext()
	const company = proxyProp(context, "company")

	return () => (
		<Tile>
			<label for="companyName" class="tile-heading">
				<Required label="Company Name" />
			</label>
			<input
				type="text"
				id="companyName"
				v-model={company.name}
				placeholder="Company Name"
				class="form-control"
				required
			/>
		</Tile>
	)
}

export default defineComponent(Name)
